import * as getters from "../../baseQuestion/dynamicDDL/store/getters";
import * as mutations from "../../baseQuestion/dynamicDDL/store/mutations";
import * as actions from "../../baseQuestion/dynamicDDL/store/actions";
import { state as dynamic_ddl_state } from "../../baseQuestion/dynamicDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_high_school",
			dependent_visible: "q_high_school_country",
			dependent_visible_values: ["CAN"],
			option_source: {
				type: "province",
				filter: []
			},
			answer_externally_updated: true
		},
		dynamic_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
